import { url } from "./url/index";
import { upload } from "./upload/index";
import transformationUtils from "./utils/transformation"
import errorMessages from "./constants/errorMessages";

const ImageKit = function (opts) {
  opts = opts || {};
  this.options = {
    sdkVersion: `javascript-1.3.4`,
    publicKey: "public_+Kctf59CFl9OGy4Z5219nymjwFA=",
    urlEndpoint: "https://ik.imagekit.io/osusf6xvdf",
    transformationPosition: transformationUtils.getDefault()
  };

  this.options = {
    ...this.options,
    ...opts
  };

  if (!mandatoryParametersAvailable(this.options)) {
    throw (errorMessages.MANDATORY_INITIALIZATION_MISSING);
  }

  if (privateKeyPassed(this.options)) {
    throw (errorMessages.PRIVATE_KEY_CLIENT_SIDE);
  }

  if (!transformationUtils.validParameters(this.options)) {
    throw (errorMessages.INVALID_TRANSFORMATION_POSITION);
  }

  /*
      URL Builder
  */
  this.url = function (urlOptions) {
    return url(urlOptions, this.options);
  };

  /*
      Upload API
  */
  this.upload = function (uploadOptions, callback, options) {
    var mergedOptions = {
      ...this.options,
      ...options
    };
    return upload(uploadOptions, mergedOptions, callback);
  };
};

function mandatoryParametersAvailable(options) {
  return options.urlEndpoint;
}

function privateKeyPassed(options) {
  return typeof options.privateKey != "undefined";
}

export default ImageKit;